module.exports = __webpack_public_path__ + "static/gem-loans-category-hero-0ca6794076ccd22d8469fd4178c08901.jpg";